// HamburgerMenuItemText.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const HamburgerMenuItemText = ({
  className = '',
  children = '',
  shouldShowRedDot = false,
}) => {
  return (
    <HamburgerMenuItemTextWrap className={className}>
      <ItemText>
        <span>{children}</span>
        {shouldShowRedDot && <RedDot />}
      </ItemText>
    </HamburgerMenuItemTextWrap>
  );
};

HamburgerMenuItemText.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  shouldShowRedDot: PropTypes.bool,
};

const HamburgerMenuItemTextWrap = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  span {
    line-height: 1.5;
  }
`;

const ItemText = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const RedDot = styled.div`
  width: 6px;
  height: 6px;
  background-color: #cf0404;
  border-radius: 50%;
`;

export default HamburgerMenuItemText;
